import { reducer as auth } from './auth'
import { reducer as landing } from './landing'
import { reducer as newsletter } from './newsletter'

export default {
  auth, landing, newsletter,
}
